import EfImg from '@elem/ui/ef-img';
import { useEffect } from 'react';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useMediaDevice } from '../../hooks';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('Oasis.ListA');
    const { locale } = useRouter();
    const IS_NA_SITES = ['us', 'ca'].includes(locale ?? '');
    const IS_EU_SITES = ['eu', 'uk'].includes(locale ?? '');
    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1735613818066/ListA-1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1735614021088/ListA-1-h5.jpg',
            title: t('card1'),
            href: '#page-oasis-C',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1735613852106/ListA-2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1735614021654/ListA-2-h5.jpg',
            title: t('card2'),
            href: '#AIDriven',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1735613818238/ListA-3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1735614021822/ListA-3-h5.jpg',
            title: t('card3'),
            href: '#SmartBackup1',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1735613818431/ListA-4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1735614021462/ListA-4-h5.jpg',
            title: t('card4'),
            href: '#Safety',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1735613818794/ListA-5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1735614021295/ListA-5-h5.jpg',
            title: t('card5'),
            href: '#CutCosts',
        },
    ];
    const { isH5 } = useMediaDevice();

    useEffect(() => {
        if (isH5) return;
        const show = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const cards = document.querySelectorAll('.listA-card') as unknown as HTMLDivElement[];
                        if (entry.intersectionRatio >= 0.2) {
                            const title = document.querySelector('#ListA .listA-title') as HTMLDivElement;
                            title.classList.add('enter');
                        }

                        if (entry.intersectionRatio >= 0.5) {
                            if (!cards) return;
                            [...cards].map((card, idx) => {
                                setTimeout(() => {
                                    card.classList.add('enter');
                                }, idx * 140);
                            });
                        }
                    }
                });
            },
            {
                threshold: [0.2, 0.5],
            },
        );
        show.observe(document.getElementById('ListA') as HTMLDivElement);
        return () => {
            show.disconnect();
        };
    }, [isH5]);

    return (
        <div className={`page-oasis-B ${styles.TheComp}`} id="ListA">
            <div className="listA-title">{t('title')}</div>
            {isH5 ? (
                <Swiper
                    className="listA-swiper"
                    modules={[Pagination]} // 注册模块
                    pagination={{ clickable: true }} // 启用 Pagination，并允许点击切换
                    slidesPerView={1}
                    spaceBetween={24}
                    loop={true} // 增加无限滑动功能
                >
                    {[list[0], list[1], list[4], list[3], list[2]].map((item, idx) => (
                        <SwiperSlide key={idx}>
                            <a className="swiper-card" href={item.href}>
                                <EfImg className="swiper-card-img" pc={item.pc} h5={item.h5} />
                                <div className="swiper-card-bottom">
                                    <div className="swiper-card-title">{item.title}</div>
                                    <div className="swiper-card-btn">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                                            <path
                                                d="M5.88331 5.98638C5.60582 5.68683 5.15601 5.68683 4.87852 5.98638C4.60104 6.28592 4.60104 6.7716 4.87852 7.07114L8.66798 11.162C8.94304 11.459 9.38816 11.462 9.66659 11.1687L13.4561 7.17736C13.737 6.88152 13.7425 6.3959 13.4684 6.09268C13.1944 5.78946 12.7446 5.78348 12.4637 6.07931L9.17655 9.54153L5.88331 5.98638Z"
                                                fill="#fff"
                                                opacity=".5"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </a>
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                <div className="listA-cards">
                    {list.map((item, idx) => (
                        <a className="listA-card" href={item.href} key={idx} style={{ gridArea: `a${idx + 1}` }}>
                            <EfImg className="listA-card-img" pc={item.pc} />
                            <div className="listA-card-bottom">
                                <div className="listA-card-title">{item.title}</div>
                                <div className="listA-card-btn">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                                        <path
                                            d="M5.88331 5.98638C5.60582 5.68683 5.15601 5.68683 4.87852 5.98638C4.60104 6.28592 4.60104 6.7716 4.87852 7.07114L8.66798 11.162C8.94304 11.459 9.38816 11.462 9.66659 11.1687L13.4561 7.17736C13.737 6.88152 13.7425 6.3959 13.4684 6.09268C13.1944 5.78946 12.7446 5.78348 12.4637 6.07931L9.17655 9.54153L5.88331 5.98638Z"
                                            fill="#fff"
                                            opacity=".5"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
}
